// extracted by mini-css-extract-plugin
export var Accent = "typography-module--Accent--1IR8c";